import {
    GetPickUpNotificationApiParameter,
    PickUpNotificationApiParameter,
    PickupNotificationModel,
    getPickupNotification,
    setPickUpNotification,
} from "@NA/Services/ADIPickUpNotification";
import { CustomApiHandler } from "@NA/Store/CustomHandlerCreator/CustomHandlerCreator";
import {
    HasOnComplete,
    HasOnSuccess,
    createHandlerChainRunnerOptionalParameter,
} from "@insite/client-framework/HandlerCreator";

type HandlerType = CustomApiHandler<
    PickUpNotificationApiParameter & HasOnSuccess & HasOnComplete,
    PickupNotificationModel
>;

export const LoadPickUpNotification: HandlerType = async (props: any) => {
    if (props.parameter.ShowCheckoutModal !== undefined && props.parameter.CartId !== undefined) {
        props.apiResult = await setPickUpNotification({
            Email: props.parameter.Email,
            CartId: props.parameter.CartId,
            ShowCheckoutModal: props.parameter.ShowCheckoutModal,
            isPage: props.parameter.isPage,
            EmailPreference: props.parameter.EmailPreference,
        })
    }
    else if (props.parameter.CartId !== undefined && props.parameter.EmailPreference === true) {
        props.apiResult = await setPickUpNotification({
            EmailPreference: props.parameter.EmailPreference,
            CartId: props.parameter.CartId,
            isPage: props.parameter.isPage,
        });
    }
    else if (props.parameter.CartId !== undefined && props.parameter.Email !== undefined && props.parameter.EmailPreference === false) {
        props.apiResult = await setPickUpNotification({
            EmailPreference: props.parameter.EmailPreference,
            CartId: props.parameter.CartId,
            Email: props.parameter.Email,
            isPage: props.parameter.isPage,
        });
    }
    else {
        props.apiResult = await setPickUpNotification({
            EmailPreference: props.parameter.EmailPreference,
            isPage: props.parameter.isPage,
        });
    }
};

export const DispatchCompletePickUpNotification: HandlerType = props => {
    props.parameter && props.parameter.onSuccess && props.parameter?.onSuccess();
};

export const chain = [LoadPickUpNotification, DispatchCompletePickUpNotification];

const setPickUpNotificationHandler = createHandlerChainRunnerOptionalParameter(
    chain,
    {
        EmailPreference: true,
        isPage: true,
        onSuccess: () => { },
        CartId: '',
        Email: '',
        ShowCheckoutModal: false
    },
    "setPickUpNotificationHandler",
);
export default setPickUpNotificationHandler;
